import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export const useAuthenticatedFetch = () => {
    const { instance } = useMsal();

    return useCallback(async (url, options = {}) => {
        const accounts = instance.getAllAccounts();
        if (!accounts[0]) {
            throw new Error('No authenticated account is available.');
        }

        const tokenResponse = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        });

        const headers = new Headers(options.headers || {});
        headers.set('x-auth-token', tokenResponse.accessToken);

        return fetch(url, {
            ...options,
            headers
        });
    }, [instance]);
};
